<app-background-pattern></app-background-pattern>
<app-view
  [direction]="ViewDirection.COLUMN"
  [align]="ViewAlign.CENTER"
  padding="80px 0"
  [gap]="Spacing.X_LARGE"
>
  <app-view [justify]="ViewJustify.CENTER" [align]="ViewAlign.CENTER">
    <app-aaptiv-logo width="100%" height="38"></app-aaptiv-logo>
    <h1 class="heading">Admin</h1>
  </app-view>
  <app-card size="xlarge" [border]="false">
    <router-outlet></router-outlet>
  </app-card>
</app-view>
